import { post } from "../client";
import { CONTACT } from "../routes";

export default {
  sendMessage: async (data) => await post(CONTACT, data, false),
};
